import { useState } from "react"

import InstantGiftExplained from "areas/instant-gift/explained"
import ShipPop from "areas/product/jewlr/ship-pop"
import Modal, { closeModal } from "components/modal"

const ShippingInformationHalfModal = () => {
  const [contentIndex, setIndex] = useState(0)

  return (
    <Modal
      contentIndex={contentIndex}
      label={contentIndex == 0 ? "Shipping Information" : "Need a Gift Today?"}
      onBack={() => setIndex(0)}
      onClose={() => {
        closeModal()
        setTimeout(() => setIndex(0), 400)
      }}
      show="#shipping-info"
      variant="squircle"
    >
      {contentIndex == 0 && (
        <ShipPop
          onNext={() => {
            setIndex(1)
          }}
        />
      )}
      {contentIndex == 1 && <InstantGiftExplained inModal />}
    </Modal>
  )
}

export default ShippingInformationHalfModal
